export const tipoOperacaoCartao = [
  { value: -1, label: 'Nenhum' },
  { value: 0, label: 'Crédito' },
  { value: 1, label: 'Débito' },
];
